import React, { useState } from 'react'
import { ProfileContainer, SideBarMenuContainer } from './styles'
import { MainContent } from './MainContent'
import { SideBar } from './SideBar'
import { useWindowSize } from '../../hooks/useWindowSize'
import { ProfileNavigatorBar } from './ProfileNavigatorBar'

export const CollectionDetails = (props) => {
  const { address } = props

  const { width } = useWindowSize()

  const [isMoreView, setIsMoreView] = useState(false)

  const handleMoreView = () => {
    setIsMoreView(prev => !prev)
  }

  return (
    <ProfileContainer>
      {address && (
        <MainContent
          address={address}
          isMoreView={isMoreView}
        />
      )}
      {width > 768 && (
        <SideBarMenuContainer style={{width: '64px'}}>
          <SideBar 
            isMoreView={isMoreView}
            handleMoreView={handleMoreView}
          />
        </SideBarMenuContainer>
      )}
      {width < 768 && (
        <ProfileNavigatorBar
          {...props}
          isMoreView={isMoreView}
          handleMoreView={handleMoreView}
        />
      )}
    </ProfileContainer>
  )
}
